import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Text from '../../Text';
import { ChartFilters, ChartSettings, UserSettings } from './style';
import CustomSelect from '../../CustomSelect';
import { withMediaQueries } from '../../../../app/hoc/withMediaQueries';
import { SAVE_PRINT_SETTINGS } from '../../../../app/redux/actions/statistics';
import TimeIntervalFilter from '../../TimeIntervalFilter';
import { EXPORT_TABS } from '.';
import Checkbox from '../../Checkbox';
import { COURSE_CATEGORIES_GET } from '../../../../app/redux/actions/courselist';
import { flattenCategories } from '../../../../utils/categories';

const ActivitiesTab = ({ categories, getCategories, savePrintSettings }) => {
  const [exportTypes, setExportTypes] = useState(['activities']);

  useEffect(() => {
    if (!categories?.length > 0) getCategories();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleCheckbox = (key) => {
    const newTypes = [...exportTypes];
    const index = newTypes.findIndex((type) => type === key);
    index < 0 ? newTypes.push(key) : newTypes.splice(index, 1);
    setExportTypes(newTypes);
  };

  useEffect(() => {
    savePrintSettings({
      key: 'export_types',
      value: exportTypes,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [exportTypes]);

  return (
    <>
      <Text type="h2" mb={8}>
        Attività
      </Text>
      <Text type="b3" mb={16}>
        Da questa sezione puoi scaricare la lista di attività presenti sulla
        piattaforma
      </Text>
      <Text type="b3" mb={16}>
        Seleziona cosa includere nell’export:
      </Text>
      <UserSettings>
        <div className="checkbox-wrapper d-flex">
          <Checkbox
            label="Includi i percorsi formativi in cui è presente l’attività"
            onChange={() => handleCheckbox('activities_courses')}
          />
        </div>
      </UserSettings>
      <ChartSettings style={{ marginTop: 32 }}>
        <ChartFilters>
          <Text type="h3" mb={8}>
            Impostazioni
          </Text>
          <Text type="b3" mb={40}>
            Seleziona il periodo temporale e la tipologia in base alle tue
            esigenze per procedere con l’export
          </Text>
          <div className="d-flex g-48">
            <div>
              <Text type="h3 mandatory" mb={16}>
                Area tematica
              </Text>
              <CustomSelect
                options={flattenCategories(categories, 0, true)}
                size="s"
                onChange={(value) =>
                  savePrintSettings({
                    key: 'single_categories',
                    value: value?.id,
                  })
                }
              />
            </div>
            <div>
              <Text type="h3" mb={16}>
                Periodo
              </Text>
              <TimeIntervalFilter
                id="filter-time-interval-modal-graphics-tab"
                forceSplitMonths
                callback={(start_date, end_date) => {
                  savePrintSettings({
                    key: 'start_date',
                    value: start_date,
                  });
                  savePrintSettings({
                    key: 'end_date',
                    value: end_date,
                  });
                }}
                maxMonthsDiff={6}
              />
            </div>
          </div>
        </ChartFilters>
      </ChartSettings>
    </>
  );
};

ActivitiesTab.propTypes = {
  categories: PropTypes.array,
  getCategories: PropTypes.func,
  savePrintSettings: PropTypes.func,
};

export default connect(
  (state) => {
    const { categories } = state.courselist;
    return { categories };
  },
  (dispatch) => ({
    getCategories: () => dispatch({ type: COURSE_CATEGORIES_GET._REQUEST }),
    savePrintSettings: ({ key, value }) =>
      dispatch({
        type: SAVE_PRINT_SETTINGS,
        key,
        value,
        tab: EXPORT_TABS.ACTIVITIES,
      }),
  })
)(withMediaQueries(ActivitiesTab));
